import { GRAY_1100, WHITE } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { FC } from 'react'
import { useAdjustEditor } from './AdjustEditor.context'
import { useTranslation } from 'react-i18next'

/** What dragging on the photo does with the current tool — in the band under the photo, where the brush bar sits in Stage */
export const AdjustHint: FC = () => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { base, tool, viewMode, blurMode, doc, zoom } = useAdjustEditor()

  const hintKey = viewMode === 'compare'
    ? 'adjust.hint.compare'
    : viewMode !== 'after' ? null
      : tool === 'crop' ? 'adjust.hint.crop'
        : tool === 'redact' ? (blurMode === 'area' ? 'adjust.hint.blur_area' : 'adjust.hint.blur_brush')
          : tool === 'annotate' ? 'adjust.hint.annotate'
            : tool === 'sticker' ? (doc.stickers.length ? 'adjust.hint.sticker_move' : 'adjust.hint.sticker_add')
              : zoom > 1 ? 'adjust.hint.pan' : null

  return (
    <>
      {base && hintKey && (
        <Stack sx={{ maxWidth: '100%', padding: '0.8rem 1.6rem', borderRadius: '4rem', backgroundColor: GRAY_1100 }}>
          <Typography sx={{ fontSize: '1.3rem', color: WHITE, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t(hintKey)}</Typography>
        </Stack>
      )}
    </>
  )
}
